import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import { TXTWCL_Want_to_hear_from_other_usersX_ELL } from './CommunityFooter.messages.json';
import styles from './CommunityFooter.scss';

const CommunityFooter: React.FC = () => (
  <div className={styles.container}>
    <Translation
      tagName="span"
      {...TXTWCL_Want_to_hear_from_other_usersX_ELL}
      values={{
        a: (msg: string) => (
          <ResolverLink resolverTag={ResolverTag.CommunityForumLoginURL}>{msg}</ResolverLink>
        )
      }}
    />
  </div>
);

export default CommunityFooter;
